import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon, Dropdown, DropdownMenuItem } from '../../../../../components';

const CenteredContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const StyledIcon = styled(Icon)`
  cursor: pointer;
`;

const ActionsCellRenderer = (params) => {
  const { data, onDeleteUser, isSameUser } = params;

  if (!data || isSameUser(data.auth0Id)) return null;

  const handleDeleteClick = () => {
    if (onDeleteUser) {
      onDeleteUser(data);
    }
  };

  return (
    <CenteredContainer>
      <Dropdown
        menuPlacement='bottom-end'
        toggleComponent={<StyledIcon name='ellipsis' displaySize={20} />}
        isNested
      >
        {({ closeMenu }) => (
          <DropdownMenuItem
            leftIcon={<Icon name='trash' size={24} displaySize={20} />}
            onMouseDown={(e) => {
              e.preventDefault();
              handleDeleteClick();
              closeMenu();
            }}
          >
            Delete
          </DropdownMenuItem>
        )}
      </Dropdown>
    </CenteredContainer>
  );
};

// ag-grid passes all props as a single params object
ActionsCellRenderer.propTypes = PropTypes.object;

export { ActionsCellRenderer };
